import DraggableDialog from 'components/Dialog';
import React from 'react';
import Box from '@material-ui/core/Box';
import { CustomText } from '../../common/Reusables';
import { Divider } from '@material-ui/core';

const MyedgeLauchPad = ({ launchPadMyedge, setLaunchPadMyedge }) => {
  return (
    <DraggableDialog
      showDialog={launchPadMyedge.isOpen}
      toggleDialog={() =>
        setLaunchPadMyedge({ ...launchPadMyedge, isOpen: false })
      }
      component={
        <Box width='400px'>
          <Box>
            <CustomText
              fontSize='16px'
              fontWeight={600}
              fontFamily='Black Sans'
            >
              {launchPadMyedge.modal.title}
            </CustomText>
          </Box>
          <Divider style={{ margin: '.5rem 0' }} />
          <Box mt='1rem'>
            {launchPadMyedge.modal.content.map((item, index) => (
              <Box mb='.7rem'>
                <CustomText
                  fontSize='14px'
                  fontWeight={600}
                  fontFamily='Black Sans'
                >
                  {index + 1}. {item.content_title}
                </CustomText>
                <CustomText
                  fontSize='12px'
                  fontWeight={400}
                  fontFamily='Black Sans'
                >
                  {item.body}
                </CustomText>
              </Box>
            ))}
          </Box>
        </Box>
      }
    />
  );
};

export default MyedgeLauchPad;
